import { useQuery } from "@apollo/client";
import {  ArchivedCaseSummaryFinanceDetailsAdhocTransaction, CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment, CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment, CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment, CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment, CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryDocument } from "../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { lookupCountryQuery } from "./identity-verification-archive-country-query"
import { Country } from "../../../../../../types/country";
import { Summary } from "./summary";
import { TransactionData } from "../../../../../shared/transactions/transactions-lite";
import { Empty } from "antd";

interface SummaryContainerProps {
  data: {
    archivedCaseId: string;
  };
}

export const SummaryContainer: React.FC<SummaryContainerProps> = (props) => {
  const { data, loading, error } = useQuery(
    CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryDocument,
    {
      variables: {
        archivedIdentityVerificationCaseSummaryId: props.data.archivedCaseId,
      },
    }
  );

  const { data: countryData, loading: countryLoading, error: countryError } = useQuery(lookupCountryQuery);

    let totalSentAmount = 0;
    let totalReceivedAmount = 0;
    if (data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions) {
      const finance = data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions ?? null;
      if (finance) {
        if (finance?.adhocTransactions?.length) {
          finance?.adhocTransactions?.
          filter(transaction => {
            const approval = transaction?.approval;
            const transactionRef = transaction?.transactionReference;
            return !((approval?.isApplicantApprovalRequired === true && approval?.isApplicantApproved !== true) || (transactionRef?.isSuccess === false))
          }).forEach((transaction) => {
            const amount = transaction?.amount;
            if (amount !== undefined && amount !== null) {
              if (amount > 0) {
                totalSentAmount += amount;
              } else if (amount < 0) {
                totalReceivedAmount += Math.abs(amount); // Add to total received if negative
              }
            }
          });
        }
        if (finance?.submission) {
          const submissionAmount = finance?.submission?.amount ?? 0;
          totalSentAmount += submissionAmount;
        }
      }
    }

    const submissionTransaction: ArchivedCaseSummaryFinanceDetailsAdhocTransaction = {
      amount: data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions?.submission?.amount ?? undefined,
      reason: `Intealth Requested for ID Verification`,
      transactionReference: {
        referenceId:data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions?.submission?.transactionReference?.referenceId,
        completedAt: data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions?.submission?.transactionReference?.completedAt,
      },
    };
  
    const adhochTransactions: CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment[] = data?.archivedIdentityVerificationCaseSummary?.financeDetails?.transactions?.adhocTransactions as CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment[] || []


const allTransactions = [...adhochTransactions, submissionTransaction];
    const transactionData: TransactionData = {
      totalReceived: totalReceivedAmount,
      totalSent: totalSentAmount,
      transactionsData: allTransactions
    };

  return (
    <ComponentQueryLoader
      loading={loading || countryLoading }
      error={error || countryError}
      hasData={!!data?.archivedIdentityVerificationCaseSummary && Object.keys(data.archivedIdentityVerificationCaseSummary).length > 0 && !!countryData}
      hasDataComponent={
        <Summary
        caseDetailsData={data?.archivedIdentityVerificationCaseSummary?.caseDetails as CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment}
        fileDetails={data?.archivedIdentityVerificationCaseSummary?.files as CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment[]}
        countryData={countryData?.countries?.eventPayload?.countries as Country[]}
        transactionData={transactionData}
        activityData={data?.archivedIdentityVerificationCaseSummary?.activityLog as CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment[]}
        />
      }
      noDataComponent={<Empty description={`No archived summary available for case ID: ${props.data.archivedCaseId}`} />}
    />
  );
};